/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { BonusInfoWrapper, Screen, ScreenDetails, CloseBtn } from './styles';
import { Svg } from 'app/components';
import { SectionInfoContent } from '../styles';

const propTypes = {
  hallTicketDetails: PropTypes.arrayOf(PropTypes.object),
  getHallTicketdetails: PropTypes.func.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.Number
    }).isRequired
  }).isRequired
};

const defaultProps = {
  hallTicketDetails: []
};

const HallTicket = ({
  getHallTicketdetails,
  hallTicketDetails,
  match
}) => {
  const linkedSeatInfo = hallTicketDetails[0]?.linkedSeatInfo;
  const [t, i18n] = useTranslation();
  const [hallTicketData, setHallTicketData] = useState([]);
  const [hall, setHall] = useState();
  const [popup, setPopUp] = useState(false)
  const { id } = match.params;

  useEffect(() => {
    if (id !== undefined && Number(id) !== 0) {
      getHallTicketdetails({ id: Number(id) });
    }
  }, [id]);

  const languageContents = useMemo(
    () => ({
      headline: i18n.language === 'en' || i18n.language === 'en-US' ? 'headlineEN' : 'headline',
      headline2: i18n.language === 'en' || i18n.language === 'en-US' ? 'headline2EN' : 'headline2',
      Description: i18n.language === 'en' || i18n.language === 'en-US' ? 'DescriptionEN' : 'Description',
      description: i18n.language === 'en' || i18n.language === 'en-US' ? 'descriptionEN' : 'description'
    }),
    [i18n.language]
  );

  useEffect(() => {
    setHallTicketData(hallTicketDetails?.[0]);
  }, [hallTicketDetails]);

  return (
    hallTicketData ?
      <BonusInfoWrapper>
        < h1 className="hall-ticket__title" > {hallTicketData?.[languageContents.headline]}</h1 >
        <div
          className="container "
        >
          <Screen className="screen">
            {hallTicketData?.hallinfos?.map(ticket => {
              return (
                <div className="screen_1">
                  <div className="screen_1_first">
                    <div
                      dangerouslySetInnerHTML={{ __html: ticket?.[languageContents.Description] }}
                    />
                  </div>
                  <div className="screen_1_second">
                    <div className="screen-img" >
                      <img src={ticket?.Picture} alt="screen-1" onClick={() => {setHall(ticket?.Picture);setPopUp(true)}}/>
                    </div>
                    {popup && <div className="screen-popup" onClick={() => setPopUp(false)}>
                      <div>
                        <div className="close-btn">
                          <CloseBtn >
                            <Svg id="close" />
                          </CloseBtn>
                        </div>
                        <img src={hall} alt="screen-1" />
                      </div>
                    </div>}
                  </div>
                </div>
              );
            })}
          </Screen>
          <ScreenDetails className="screen-details">
            {linkedSeatInfo?.map(ticket => {
              return (
                <div className="screen-details-card">
                  <div className="letter-container">
                    <div className={ticket.key === 'LoveChair' || ticket.key ==='Cinegold Lovebox' || ticket.key === 'Lovebox' ? 'letter-pad2' : 'letter-pad'}>
                      <img src={ticket?.picture} alt="ticket-pic" />
                    </div>
                    <span className={ticket.key}> {ticket?.[languageContents.headline]}</span>
                  </div>
                  <p className="screen-card-heading2">{ticket?.[languageContents.headline2]}</p>
                  <p
                    className="screen-card-details"
                    dangerouslySetInnerHTML={{ __html: ticket?.[languageContents.description] }}
                  />
                </div>
              );
            })}
          </ScreenDetails>
        </div>
      </BonusInfoWrapper >
      :
      <BonusInfoWrapper>
        <SectionInfoContent>
          <h2 style={{ textAlign: 'center' }}>{t('common.coming_soon')}</h2>
        </SectionInfoContent>
      </BonusInfoWrapper>
  );
};

HallTicket.propTypes = propTypes;
HallTicket.defaultProps = defaultProps;
export default HallTicket;
